import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm$payment;
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": _vm.options.width
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    attrs: {
      disabled: _vm.isValidating
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v(_vm._s(_vm.isAdding ? "Add new payment" : "Edit payment"))])]), _c(VCardText, [_c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    staticClass: "v-text-field required",
    attrs: {
      label: "Amount (".concat(_vm.getSymbolCurrency(_vm.inboundDelivery.currency), ")"),
      placeholder: "0.00",
      type: "number",
      min: "0.01",
      max: _vm.remainingAmount,
      required: "",
      rules: [_vm.rules.mustBeGreaterThan0],
      "hide-details": "auto"
    },
    on: {
      blur: _vm.changeAmountCurrency
    },
    model: {
      value: _vm.model.amount,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "amount", $$v);
      },
      expression: "model.amount"
    }
  })], 1), _c("div", {
    staticClass: "mt-4"
  }, [_c(VSelect, {
    staticClass: "required",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: "Payment state",
      items: _vm.paymentStates,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "auto",
      rules: [_vm.rules.mustNotBeEmpty]
    },
    model: {
      value: _vm.model.state,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "state", $$v);
      },
      expression: "model.state"
    }
  })], 1), _vm.model.state === _vm.paymentState.SUCCEEDED ? _c("div", {
    staticClass: "mt-4"
  }, [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field required",
          attrs: {
            type: "date",
            label: "Payment date",
            "hide-details": "auto",
            required: "",
            rules: [_vm.rules.mustNotBeEmpty]
          },
          model: {
            value: _vm.model.paymentDate,
            callback: function callback($$v) {
              _vm.$set(_vm.model, "paymentDate", $$v);
            },
            expression: "model.paymentDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }], null, false, 3660086641),
    model: {
      value: _vm.paymentDateMenu,
      callback: function callback($$v) {
        _vm.paymentDateMenu = $$v;
      },
      expression: "paymentDateMenu"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        _vm.paymentDateMenu = false;
      }
    },
    model: {
      value: _vm.model.paymentDate,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "paymentDate", $$v);
      },
      expression: "model.paymentDate"
    }
  })], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "mt-4"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_c("div", {
    staticClass: "flex"
  }, [_c("i", {
    staticClass: "fas fa-receipt"
  }), _vm._v(" Payment method (Stripe) "), _vm.isPaymentEditable ? _c("div", {
    staticClass: "ml-2 flex gap-2"
  }, [_c(VIcon, {
    staticClass: "fas fa-pen",
    attrs: {
      title: "Edit",
      size: "1rem"
    },
    on: {
      click: function click($event) {
        return _vm.startEditPaymentMethod();
      }
    }
  }), _vm.model.methodId ? _c(VIcon, {
    staticClass: "fas fa-trash",
    attrs: {
      title: "Remove",
      size: "1rem"
    },
    on: {
      click: function click($event) {
        return _vm.removePaymentMethod();
      }
    }
  }) : _vm._e()], 1) : _vm._e()])]), !_vm.isEditingPayment ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm._v(" " + _vm._s(_vm.model.methodId ? _vm.model.typeLabel : "No payment method") + " ")]) : _vm._e(), !_vm.isAdding && _vm.isPaymentEditable ? _c("div", {
    staticClass: "text-italic text-sm"
  }, [_vm._v(" Changing this can potentially affect direct debit. ")]) : _vm._e(), _vm.isEditingPayment ? [_vm.listPaymentMethods.length === 0 ? _c("div", {
    staticClass: "inbound-delivery-maincontent-data-value"
  }, [_vm._v(" No payment method saved in customer wallet ")]) : _c("div", [_c(VCombobox, {
    staticClass: "v-text-field-no-label mb-2",
    attrs: {
      small: "",
      items: _vm.listPaymentMethods,
      "item-text": "label",
      "item-value": "payment_method_id",
      "hide-details": "auto",
      "hide-selected": true,
      clearable: "",
      "return-object": ""
    },
    model: {
      value: _vm.modelPaymentMethod,
      callback: function callback($$v) {
        _vm.modelPaymentMethod = $$v;
      },
      expression: "modelPaymentMethod"
    }
  })], 1), _c("div", {
    staticClass: "flex gap-3"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 secondary",
    attrs: {
      rounded: "",
      "data-cy": "payment-edit-cancel-button"
    },
    on: {
      click: function click($event) {
        return _vm.cancelPaymentMethod();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-times mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Cancel ")], 1), _c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: "",
      "data-cy": "payment-edit-save-button",
      disabled: !_vm.modelPaymentMethod
    },
    on: {
      click: function click($event) {
        return _vm.updatePaymentMethod();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-save mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Save payment method ")], 1)], 1)] : _vm._e()], 2), !_vm.model.methodId ? _c("div", {
    staticClass: "mt-4"
  }, [_c(VSelect, {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      label: "Payment method (External)",
      "item-text": "name",
      "item-value": "id",
      items: _vm.paymentTypes,
      "hide-details": "auto"
    },
    model: {
      value: _vm.model.type,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "type", $$v);
      },
      expression: "model.type"
    }
  })], 1) : _c("div", {
    staticClass: "mt-4"
  }, [_c(VMenu, {
    attrs: {
      "close-on-content-click": false,
      transition: "scale-transition",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c(VTextField, _vm._g(_vm._b({
          staticClass: "v-text-field",
          attrs: {
            type: "date",
            label: "Schedule date",
            "hide-details": "auto",
            clearable: ""
          },
          model: {
            value: _vm.model.scheduleDate,
            callback: function callback($$v) {
              _vm.$set(_vm.model, "scheduleDate", $$v);
            },
            expression: "model.scheduleDate"
          }
        }, "v-text-field", attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.scheduleDateOpened,
      callback: function callback($$v) {
        _vm.scheduleDateOpened = $$v;
      },
      expression: "scheduleDateOpened"
    }
  }, [_c(VDatePicker, {
    on: {
      input: function input($event) {
        _vm.scheduleDateOpened = false;
      }
    },
    model: {
      value: _vm.model.scheduleDate,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "scheduleDate", $$v);
      },
      expression: "model.scheduleDate"
    }
  })], 1)], 1), !!((_vm$payment = _vm.payment) !== null && _vm$payment !== void 0 && _vm$payment.microDepositsUrl) ? _c("div", {
    staticClass: "micro-deposits"
  }, [_c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-money-check-alt font-sm"
  }), _vm._v(" Micro-deposits link ")]), _c("a", {
    staticClass: "micro-deposits-url",
    attrs: {
      href: _vm.payment.microDepositsUrl,
      target: "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.payment.microDepositsUrl) + " ")])]) : _vm._e(), _c("div", {
    staticClass: "mt-4"
  }, [_c(VTextField, {
    staticClass: "v-text-field",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "text",
      label: "Payment reference",
      "hide-details": "auto"
    },
    model: {
      value: _vm.model.reference,
      callback: function callback($$v) {
        _vm.$set(_vm.model, "reference", $$v);
      },
      expression: "model.reference"
    }
  })], 1), _c("div", {
    staticClass: "mt-4 tip"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" If you choose "), _c("strong", [_vm._v("Succeeded")]), _vm._v(" make sure that the payment has been made. ")])]), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: _vm.isValidating
    },
    on: {
      click: _vm.close
    }
  }, [_vm._v(" Cancel ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: "",
      disabled: _vm.isDisabled,
      loading: _vm.isValidating
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v(" " + _vm._s(_vm.isAdding ? "Add" : "Save") + " ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };